import * as api from '../api/owner';
import * as eventApi from '@modules/events/api/event';

import { createRequestTypes, START, SUCCESS, ERROR } from './global';
import { makeApiActionCreatorV3 } from '@actions/utils';

const namespace = 'APPRAISAL';

export const OWNER_SEARCH_OPTIONS_FETCH_START =
  'APPRAISAL/OWNER_SEARCH_OPTIONS_FETCH_START';
export const OWNER_SEARCH_OPTIONS_FETCH_SUCCESS =
  'APPRAISAL/OWNER_SEARCH_OPTIONS_FETCH_SUCCESS';
export const OWNER_SEARCH_OPTIONS_FETCH_ERROR =
  'APPRAISAL/OWNER_SEARCH_OPTIONS_FETCH_ERROR';

export const OWNER_SEARCH_START = 'APPRAISAL/OWNER_SEARCH_START';
export const OWNER_SEARCH_SUCCESS = 'APPRAISAL/OWNER_SEARCH_SUCCESS';
export const OWNER_SEARCH_ERROR = 'APPRAISAL/OWNER_SEARCH_ERROR';

export const OWNER_TAGS_FETCH_START = 'APPRAISAL/OWNER_TAGS_FETCH_START';
export const OWNER_TAGS_FETCH_SUCCESS = 'APPRAISAL/OWNER_TAGS_FETCH_SUCCESS';
export const OWNER_TAGS_FETCH_ERROR = 'APPRAISAL/OWNER_TAGS_FETCH_ERROR';

export const OWNER_FIELDS_FETCH_START = 'APPRAISAL/OWNER_FIELDS_FETCH_START';
export const OWNER_FIELDS_FETCH_SUCCESS =
  'APPRAISAL/OWNER_FIELDS_FETCH_SUCCESS';
export const OWNER_FIELDS_FETCH_ERROR = 'APPRAISAL/OWNER_FIELDS_FETCH_ERROR';

export const OWNER_CHANGE_CURRENT_PAGE = 'APPRAISAL/OWNER_CHANGE_CURRENT_PAGE';
export const OWNER_CHANGE_SORT_MODEL = 'APPRAISAL/OWNER_CHANGE_SORT_MODEL';
export const OWNER_CHANGE_PAGE_SIZE = 'APPRAISAL/OWNER_CHANGE_PAGE_SIZE';

export const OWNER_RESET_DATA = 'APPRAISAL/OWNER_RESET_DATA';
export const OWNER_FETCH_START = 'APPRAISAL/OWNER_FETCH_START';
export const OWNER_FETCH_SUCCESS = 'APPRAISAL/OWNER_FETCH_SUCCESS';
export const OWNER_FETCH_ERROR = 'APPRAISAL/OWNER_FETCH_ERROR';

export const OWNER_UPDATE_START = 'APPRAISAL/OWNER_UPDATE_START';
export const OWNER_UPDATE_SUCCESS = 'APPRAISAL/OWNER_UPDATE_SUCCESS';
export const OWNER_UPDATE_ERROR = 'APPRAISAL/OWNER_UPDATE_ERROR';

export const OWNER_NOTES_FETCH_START = 'APPRAISAL/OWNER_NOTES_FETCH_START';
export const OWNER_NOTES_FETCH_SUCCESS = 'APPRAISAL/OWNER_NOTES_FETCH_SUCCESS';
export const OWNER_NOTES_FETCH_ERROR = 'APPRAISAL/OWNER_NOTES_FETCH_ERROR';

export const OWNER_PROPERTIES_FETCH_START =
  'APPRAISAL/OWNER_PROPERTIES_FETCH_START';
export const OWNER_PROPERTIES_FETCH_SUCCESS =
  'APPRAISAL/OWNER_PROPERTIES_FETCH_SUCCESS';
export const OWNER_PROPERTIES_FETCH_ERROR =
  'APPRAISAL/OWNER_PROPERTIES_FETCH_ERROR';

export const OWNER_NOTE_ADD_START = 'APPRAISAL/OWNER_NOTE_ADD_START';
export const OWNER_NOTE_ADD_SUCCESS = 'APPRAISAL/OWNER_NOTE_ADD_SUCCESS';
export const OWNER_NOTE_ADD_ERROR = 'APPRAISAL/OWNER_NOTE_ADD_ERROR';

export const OWNER_NOTE_UPDATE_START = 'APPRAISAL/OWNER_NOTE_UPDATE_START';
export const OWNER_NOTE_UPDATE_SUCCESS = 'APPRAISAL/OWNER_NOTE_UPDATE_SUCCESS';
export const OWNER_NOTE_UPDATE_ERROR = 'APPRAISAL/OWNER_NOTE_UPDATE_ERROR';

export const OWNER_NOTE_DELETE_START = 'APPRAISAL/OWNER_NOTE_DELETE_START';
export const OWNER_NOTE_DELETE_SUCCESS = 'APPRAISAL/OWNER_NOTE_DELETE_SUCCESS';
export const OWNER_NOTE_DELETE_ERROR = 'APPRAISAL/OWNER_NOTE_DELETE_ERROR';

export const OWNER_VALIDATE_START = 'APPRAISAL/OWNER_VALIDATE_START';
export const OWNER_VALIDATE_SUCCESS = 'APPRAISAL/OWNER_VALIDATE_SUCCESS';
export const OWNER_VALIDATE_ERROR = 'APPRAISAL/OWNER_VALIDATE_ERROR';

export const OWNER_VALIDATE_ADDRESS_START =
  'APPRAISAL/OWNER_VALIDATE_ADDRESS_START';
export const OWNER_VALIDATE_ADDRESS_SUCCESS =
  'APPRAISAL/OWNER_VALIDATE_ADDRESS_SUCCESS';
export const OWNER_VALIDATE_ADDRESS_ERROR =
  'APPRAISAL/OWNER_VALIDATE_ADDRESS_ERROR';

export const OWNER_CREATE = createRequestTypes('APPRAISAL/OWNER_CREATE');

export const OWNER_TAGS_FOR_OWNER_FETCH = createRequestTypes(
  'APPRAISAL/OWNER_TAGS_FOR_OWNER_FETCH',
);

export const OWNER_FETCH_CODEFILE_OWNER_TAGS = createRequestTypes(
  'APPRAISAL/OWNER_FETCH_CODEFILE_OWNER_TAGS',
);

export const OWNER_TAG_INSERT = createRequestTypes(
  'APPRAISAL/OWNER_TAG_INSERT',
);

export const OWNER_TAG_DELETE = createRequestTypes(
  'APPRAISAL/OWNER_TAG_DELETE',
);

export const OWNER_TAG_UPDATE_START = 'APPRAISAL/OWNER_TAG_UPDATE_START';
export const OWNER_TAG_UPDATE_SUCCESS = 'APPRAISAL/OWNER_TAG_UPDATE_SUCCESS';
export const OWNER_TAG_UPDATE_ERROR = 'APPRAISAL/OWNER_TAG_UPDATE_ERROR';

export const OPEN_OWNER_LOOKUP_MODAL = 'APPRAISAL/OPEN_OWNER_LOOKUP_MODAL';
export const CLOSE_OWNER_LOOKUP_MODAL = 'APPRAISAL/CLOSE_OWNER_LOOKUP_MODAL';
export const LOOKUP_OWNER = createRequestTypes('APPRAISAL/LOOKUP_OWNER');
export const OWNER_MODAL_CHANGE_CURRENT_PAGE =
  'APPRAISAL/OWNER_MODAL_CHANGE_CURRENT_PAGE';
export const MODAL_SELECT_OWNER_RECORDS =
  'APPRAISAL/MODAL_SELECT_OWNER_RECORDS';

export const OPEN_OWNER_CREATE_MODAL = 'APPRAISAL/OPEN_OWNER_CREATE_MODAL';
export const CLOSE_OWNER_CREATE_MODAL = 'APPRAISAL/CLOSE_OWNER_CREATE_MODAL';
export const RESET_OWNER_CREATE_MODAL = 'APPRAISAL/RESET_OWNER_CREATE_MODAL';
export const OWNER_CREATE_MODAL_RESULT = 'APPRAISAL/OWNER_CREATE_MODAL_RESULT';

export const OPEN_OWNER_EDIT_MODAL = 'APPRAISAL/OPEN_OWNER_EDIT_MODAL';
export const CLOSE_OWNER_EDIT_MODAL = 'APPRAISAL/CLOSE_OWNER_EDIT_MODAL';

// Ownership Transfer Walkthrough >>>
export const OWNERSHIP_TRANSFER_SET_RETURN_URL =
  'APPRAISAL/OWNERSHIP_TRANSFER_SET_RETURN_URL';
export const PROPERTY_FETCH_LISTING = createRequestTypes(
  'APPRAISAL/PROPERTY_FETCH_LISTING',
);
export const PROPERTY_RESET_LISTING = 'APPRAISAL/PROPERTY_RESET_LISTING';

export const PROPERTY_REMOVE_RECORD = 'APPRAISAL/PROPERTY_REMOVE_RECORD';

export const PROPERTY_OWNER_LISTING_FETCH = createRequestTypes(
  'APPRAISAL/PROPERTY_OWNER_LISTING_FETCH',
);

export const PROPERTY_OWNER_LISTING_RESET =
  'APPRAISAL/PROPERTY_OWNER_LISTING_RESET';

export const OWNERSHIP_TRANSFER_CHANGE_SELLER_PCT =
  'APPRAISAL/OWNERSHIP_TRANSFER_CHANGE_SELLER_PCT';

export const OWNERSHIP_TRANSFER_RESET_SELLER_PCT =
  'APPRAISAL/OWNERSHIP_TRANSFER_RESET_SELLER_PCT';

export const OWNERSHIP_TRANSFER_ADD_BUYER =
  'APPRAISAL/OWNERSHIP_TRANSFER_ADD_BUYER';
export const OWNERSHIP_TRANSFER_REMOVE_BUYER =
  'APPRAISAL/OWNERSHIP_TRANSFER_REMOVE_BUYER';
export const OWNERSHIP_TRANSFER_CHANGE_BUYER_PCT =
  'APPRAISAL/OWNERSHIP_TRANSFER_CHANGE_BUYER_PCT';

export const OWNERSHIP_TRANSFER_PROPERTIES =
  'APPRAISAL/OWNERSHIP_TRANSFER_PROPERTIES';

export const OWNER_EXEMPTION_LISTING_FETCH = createRequestTypes(
  'APPRAISAL/OWNER_EXEMPTION_LISTING_FETCH',
);

export const OWNER_EXEMPTION_LISTING_UPDATE =
  'APPRAISAL/OWNER_EXEMPTION_LISTING_UPDATE';

export const OWNERSHIP_TRANSFER_RESET = 'APPRAISAL/OWNERSHIP_TRANSFER_RESET';

export const OWNERSHIP_TRANSFER_SUBMIT = createRequestTypes(
  'APPRAISAL/OWNERSHIP_TRANSFER_SUBMIT',
);

export const OWNER_GROUPS_RESET = 'APPRAISAL/OWNER_GROUPS_RESET';

export const OWNER_GROUPS_FETCH = createRequestTypes(
  'APPRAISAL/OWNER_GROUPS_FETCH',
);

export const OWNER_GROUP_ADD = createRequestTypes('APPRAISAL/OWNER_GROUP_ADD');

export const OWNER_GROUP_CREATE = createRequestTypes(
  'APPRAISAL/OWNER_GROUP_CREATE',
);

export const OWNER_GROUP_DELETE = createRequestTypes(
  'APPRAISAL/OWNER_GROUP_DELETE',
);

export const OWNER_GROUP_SET_PRIMARY = createRequestTypes(
  'APPRAISAL/OWNER_GROUP_SET_PRIMARY',
);

export const OWNER_GROUP_ADD_OR_CREATE = createRequestTypes(
  'APPRAISAL/OWNER_GROUP_ADD_OR_CREATE',
);
// <<< Ownership Transfer Walkthrough

export const OWNER_NUMBER_ADD = createRequestTypes(
  'APPRAISAL/OWNER_NUMBER_ADD',
);

export const OWNER_NUMBER_FETCH = createRequestTypes(
  'APPRAISAL/OWNER_NUMBER_FETCH',
);

export const OWNER_NUMBER_DELETE = createRequestTypes(
  'APPRAISAL/OWNER_NUMBER_DELETE',
);

export const OWNER_NUMBER_FETCH_ALL = createRequestTypes(
  'APPRAISAL/OWNER_NUMBER_FETCH_ALL',
);

export const OWNER_NUMBER_UPDATE = createRequestTypes(
  'APPRAISAL/OWNER_NUMBER_UPDATE',
);

export const addOwnerNumber = makeApiActionCreatorV3(
  api.addOwnerNumber,
  OWNER_NUMBER_ADD[START],
  OWNER_NUMBER_ADD[SUCCESS],
  OWNER_NUMBER_ADD[ERROR],
);

export const fetchAllOwnerNumbers = makeApiActionCreatorV3(
  api.fetchAllOwnerNumbers,
  OWNER_NUMBER_FETCH_ALL[START],
  OWNER_NUMBER_FETCH_ALL[SUCCESS],
  OWNER_NUMBER_FETCH_ALL[ERROR],
);

export const deleteOwnerNumber = makeApiActionCreatorV3(
  api.deleteOwnerNumber,
  OWNER_NUMBER_DELETE[START],
  OWNER_NUMBER_DELETE[SUCCESS],
  OWNER_NUMBER_DELETE[ERROR],
);

export const updateOwnerNumber = makeApiActionCreatorV3(
  api.updateOwnerNumber,
  OWNER_NUMBER_UPDATE[START],
  OWNER_NUMBER_UPDATE[SUCCESS],
  OWNER_NUMBER_UPDATE[ERROR],
);

export const openOwnerLookupModal = mode => ({
  type: OPEN_OWNER_LOOKUP_MODAL,
  payload: mode,
});

export const closeOwnerLookupModal = () => ({
  type: CLOSE_OWNER_LOOKUP_MODAL,
});

export const openOwnerCreateModal = () => ({
  type: OPEN_OWNER_CREATE_MODAL,
});

export const closeOwnerCreateModal = () => ({
  type: CLOSE_OWNER_CREATE_MODAL,
});

export const resetOwnerCreateModal = () => ({
  type: RESET_OWNER_CREATE_MODAL,
});

export const setOwnerCreateModalResult = result => ({
  type: OWNER_CREATE_MODAL_RESULT,
  data: result,
});

export const openOwnerEditModal = ownerId => ({
  type: OPEN_OWNER_EDIT_MODAL,
  data: ownerId,
});

export const closeOwnerEditModal = () => ({
  type: CLOSE_OWNER_EDIT_MODAL,
});

export const lookupOwner = makeApiActionCreatorV3(
  api.lookupOwner,
  LOOKUP_OWNER[START],
  LOOKUP_OWNER[SUCCESS],
  LOOKUP_OWNER[ERROR],
);

export const ownerLookupModalSelectRecords = owners => ({
  type: MODAL_SELECT_OWNER_RECORDS,
  payload: owners,
});

export const fetchSearchOptions = makeApiActionCreatorV3(
  api.fetchSearchOptions,
  OWNER_SEARCH_OPTIONS_FETCH_START,
  OWNER_SEARCH_OPTIONS_FETCH_SUCCESS,
  OWNER_SEARCH_OPTIONS_FETCH_ERROR,
);
export const searchOwner = makeApiActionCreatorV3(
  api.searchOwner,
  OWNER_SEARCH_START,
  OWNER_SEARCH_SUCCESS,
  OWNER_SEARCH_ERROR,
);
export const fetchFields = makeApiActionCreatorV3(
  api.fetchFields,
  OWNER_FIELDS_FETCH_START,
  OWNER_FIELDS_FETCH_SUCCESS,
  OWNER_FIELDS_FETCH_ERROR,
);
export const fetchTags = makeApiActionCreatorV3(
  api.fetchTags,
  OWNER_TAGS_FETCH_START,
  OWNER_TAGS_FETCH_SUCCESS,
  OWNER_TAGS_FETCH_ERROR,
);

export const fetchOwnerTags = makeApiActionCreatorV3(
  api.fetchOwnerTags,
  OWNER_TAGS_FOR_OWNER_FETCH[START],
  OWNER_TAGS_FOR_OWNER_FETCH[SUCCESS],
  OWNER_TAGS_FOR_OWNER_FETCH[ERROR],
);
export const fetchCodefileOwnerTags = makeApiActionCreatorV3(
  api.fetchCodefileOwnerTags,
  OWNER_FETCH_CODEFILE_OWNER_TAGS[START],
  OWNER_FETCH_CODEFILE_OWNER_TAGS[SUCCESS],
  OWNER_FETCH_CODEFILE_OWNER_TAGS[ERROR],
);

export const insertOwnerTag = makeApiActionCreatorV3(
  api.insertOwnerTag,
  OWNER_TAG_INSERT[START],
  OWNER_TAG_INSERT[SUCCESS],
  OWNER_TAG_INSERT[ERROR],
);

export const deleteOwnerTag = makeApiActionCreatorV3(
  api.deleteOwnerTag,
  OWNER_TAG_DELETE[START],
  OWNER_TAG_DELETE[SUCCESS],
  OWNER_TAG_DELETE[ERROR],
);

export const fetchOwner = makeApiActionCreatorV3(
  api.fetchOwner,
  OWNER_FETCH_START,
  OWNER_FETCH_SUCCESS,
  OWNER_FETCH_ERROR,
);

export const updateOwner = makeApiActionCreatorV3(
  api.updateOwner,
  OWNER_UPDATE_START,
  OWNER_UPDATE_SUCCESS,
  OWNER_UPDATE_ERROR,
);
export const createOwner = makeApiActionCreatorV3(
  api.createOwner,
  OWNER_CREATE[START],
  OWNER_CREATE[SUCCESS],
  OWNER_CREATE[ERROR],
);
export const fetchOwnerNotes = makeApiActionCreatorV3(
  api.fetchOwnerNotes,
  OWNER_NOTES_FETCH_START,
  OWNER_NOTES_FETCH_SUCCESS,
  OWNER_NOTES_FETCH_ERROR,
);
export const fetchOwnerProperties = makeApiActionCreatorV3(
  api.fetchOwnerProperties,
  OWNER_PROPERTIES_FETCH_START,
  OWNER_PROPERTIES_FETCH_SUCCESS,
  OWNER_PROPERTIES_FETCH_ERROR,
);
export const updateOwnerNote = makeApiActionCreatorV3(
  api.updateOwnerNote,
  OWNER_NOTE_UPDATE_START,
  OWNER_NOTE_UPDATE_SUCCESS,
  OWNER_NOTE_UPDATE_ERROR,
);
export const updateOwnerTag = makeApiActionCreatorV3(
  api.updateOwnerTag,
  OWNER_TAG_UPDATE_START,
  OWNER_TAG_UPDATE_SUCCESS,
  OWNER_TAG_UPDATE_ERROR,
);
export const addOwnerNote = makeApiActionCreatorV3(
  api.addOwnerNote,
  OWNER_NOTE_ADD_START,
  OWNER_NOTE_ADD_SUCCESS,
  OWNER_NOTE_ADD_ERROR,
);
export const deleteOwnerNote = makeApiActionCreatorV3(
  api.deleteOwnerNote,
  OWNER_NOTE_DELETE_START,
  OWNER_NOTE_DELETE_SUCCESS,
  OWNER_NOTE_DELETE_ERROR,
);
export const validateOwner = makeApiActionCreatorV3(
  api.validateOwner,
  OWNER_VALIDATE_START,
  OWNER_VALIDATE_SUCCESS,
  OWNER_VALIDATE_ERROR,
);
export const validateOwnerAddress = makeApiActionCreatorV3(
  api.validateOwnerAddress,
  OWNER_VALIDATE_ADDRESS_START,
  OWNER_VALIDATE_ADDRESS_SUCCESS,
  OWNER_VALIDATE_ADDRESS_ERROR,
);

export const fetchPropertyOwnerListing = makeApiActionCreatorV3(
  api.fetchPropertyOwnerListing,
  PROPERTY_OWNER_LISTING_FETCH[START],
  PROPERTY_OWNER_LISTING_FETCH[SUCCESS],
  PROPERTY_OWNER_LISTING_FETCH[ERROR],
);

export const resetPropertyOwnerListing = () => ({
  type: PROPERTY_OWNER_LISTING_RESET,
});

export function changeCurrentPage(page) {
  return async dispatch => {
    dispatch({ type: OWNER_CHANGE_CURRENT_PAGE, data: page });
  };
}

export function changeSortModel(model) {
  return async dispatch => {
    dispatch({ type: OWNER_CHANGE_SORT_MODEL, data: model });
  };
}

export function changePageSize(page) {
  return async dispatch => {
    dispatch({ type: OWNER_CHANGE_PAGE_SIZE, data: page });
  };
}

export function resetOwnerData() {
  return async dispatch => {
    dispatch({ type: OWNER_RESET_DATA });
  };
}

// Property Ownership Transfer >>>
export const setOwnershipTransferReturnUrl = url => ({
  type: OWNERSHIP_TRANSFER_SET_RETURN_URL,
  data: url,
});

export const fetchPropertyListing = makeApiActionCreatorV3(
  api.fetchPropertyListing,
  PROPERTY_FETCH_LISTING[START],
  PROPERTY_FETCH_LISTING[SUCCESS],
  PROPERTY_FETCH_LISTING[ERROR],
);

export const resetPropertyListing = () => ({
  type: PROPERTY_RESET_LISTING,
});

export const removePropertyRecord = propertyId => ({
  type: PROPERTY_REMOVE_RECORD,
  data: propertyId,
});

export const fetchPropertyTransferOwnerListing = makeApiActionCreatorV3(
  api.fetchPropertyOwnerListing,
  PROPERTY_OWNER_LISTING_FETCH[START],
  PROPERTY_OWNER_LISTING_FETCH[SUCCESS],
  PROPERTY_OWNER_LISTING_FETCH[ERROR],
);

export const resetPropertyTransferOwnerListing = () => ({
  type: PROPERTY_OWNER_LISTING_RESET,
});

export function changeOwnershipTransferSellerPct(seller) {
  return {
    type: OWNERSHIP_TRANSFER_CHANGE_SELLER_PCT,
    data: seller,
  };
}

export function resetOwnershipTransferSellerPcts() {
  return {
    type: OWNERSHIP_TRANSFER_RESET_SELLER_PCT,
  };
}

export function addOwnershipTransferBuyer(buyer) {
  return {
    type: OWNERSHIP_TRANSFER_ADD_BUYER,
    data: buyer,
  };
}

export function removeOwnershipTransferBuyer(buyer) {
  return {
    type: OWNERSHIP_TRANSFER_REMOVE_BUYER,
    data: buyer,
  };
}

export function changeOwnershipTransferBuyerPct(data) {
  return {
    type: OWNERSHIP_TRANSFER_CHANGE_BUYER_PCT,
    data,
  };
}

export const fetchOwnerExemptionListing = makeApiActionCreatorV3(
  api.fetchOwnerExemptionListing,
  OWNER_EXEMPTION_LISTING_FETCH[START],
  OWNER_EXEMPTION_LISTING_FETCH[SUCCESS],
  OWNER_EXEMPTION_LISTING_FETCH[ERROR],
);

export function updateOwnerShipTransferExemptions(data) {
  return {
    type: OWNER_EXEMPTION_LISTING_UPDATE,
    data,
  };
}

export function resetOwnershipTransferData() {
  return {
    type: OWNERSHIP_TRANSFER_RESET,
  };
}

export const submitOwnershipTransfer = makeApiActionCreatorV3(
  api.postOwnershipTransfer,
  OWNERSHIP_TRANSFER_SUBMIT[START],
  OWNERSHIP_TRANSFER_SUBMIT[SUCCESS],
  OWNERSHIP_TRANSFER_SUBMIT[ERROR],
);

// owner events
export const OWNER_EVENTS_FETCH = createRequestTypes(
  'APPRAISAL/OWNER/OWNER_EVENTS_FETCH',
);

export const fetchOwnerEvents = makeApiActionCreatorV3(
  api.fetchOwnerEvents,
  OWNER_EVENTS_FETCH[START],
  OWNER_EVENTS_FETCH[SUCCESS],
  OWNER_EVENTS_FETCH[ERROR],
);

export const OWNER_EVENT_DELETE = createRequestTypes(
  'APPRAISAL/OWNER/OWNER_EVENT_DELETE',
);
export const deleteOwnerEvent = makeApiActionCreatorV3(
  eventApi.deleteEvent,
  OWNER_EVENT_DELETE[START],
  OWNER_EVENT_DELETE[SUCCESS],
  OWNER_EVENT_DELETE[ERROR],
);

export const fetchOwnerGroups = makeApiActionCreatorV3(
  api.fetchOwnerGroups,
  OWNER_GROUPS_FETCH[START],
  OWNER_GROUPS_FETCH[SUCCESS],
  OWNER_GROUPS_FETCH[ERROR],
);

export const addOwnerGroup = makeApiActionCreatorV3(
  api.addOwnerGroup,
  OWNER_GROUP_ADD[START],
  OWNER_GROUP_ADD[SUCCESS],
  OWNER_GROUP_ADD[ERROR],
);

export const createOwnerGroup = makeApiActionCreatorV3(
  api.createOwnerGroup,
  OWNER_GROUP_CREATE[START],
  OWNER_GROUP_CREATE[SUCCESS],
  OWNER_GROUP_CREATE[ERROR],
);

export const deleteOwnerGroup = makeApiActionCreatorV3(
  api.deleteOwnerGroup,
  OWNER_GROUP_DELETE[START],
  OWNER_GROUP_DELETE[SUCCESS],
  OWNER_GROUP_DELETE[ERROR],
);

export const setPrimaryOwnerGroup = makeApiActionCreatorV3(
  api.setPrimaryOwnerGroup,
  OWNER_GROUP_SET_PRIMARY[START],
  OWNER_GROUP_SET_PRIMARY[SUCCESS],
  OWNER_GROUP_SET_PRIMARY[ERROR],
);

export const addOrCreateOwnerGroup = makeApiActionCreatorV3(
  api.addOrCreateOwnerGroup,
  OWNER_GROUP_ADD_OR_CREATE[START],
  OWNER_GROUP_ADD_OR_CREATE[SUCCESS],
  OWNER_GROUP_ADD_OR_CREATE[ERROR],
);

export function resetOwnerGroups() {
  return {
    type: OWNER_GROUPS_RESET,
  };
}
// <<< Property Ownership Transfer

export const FETCH_OWNER_NAME_ALIASES = createRequestTypes(
  `${namespace}/FETCH_OWNER_NAME_ALIASES`,
);

export const fetchOwnerNameAliases = makeApiActionCreatorV3(
  api.fetchOwnerNameAliases,
  FETCH_OWNER_NAME_ALIASES[START],
  FETCH_OWNER_NAME_ALIASES[SUCCESS],
  FETCH_OWNER_NAME_ALIASES[ERROR],
);

export const CREATE_OWNER_NAME_ALIAS = createRequestTypes(
  `${namespace}/CREATE_OWNER_NAME_ALIAS`,
);

export const createOwnerNameAlias = makeApiActionCreatorV3(
  api.createOwnerNameAlias,
  CREATE_OWNER_NAME_ALIAS[START],
  CREATE_OWNER_NAME_ALIAS[SUCCESS],
  CREATE_OWNER_NAME_ALIAS[ERROR],
);

export const FETCH_OWNER_NAME_ALIAS = createRequestTypes(
  `${namespace}/FETCH_OWNER_NAME_ALIAS`,
);

export const fetchOwnerNameAlias = makeApiActionCreatorV3(
  api.fetchOwnerNameAlias,
  FETCH_OWNER_NAME_ALIAS[START],
  FETCH_OWNER_NAME_ALIAS[SUCCESS],
  FETCH_OWNER_NAME_ALIAS[ERROR],
);

export const UPDATE_OWNER_NAME_ALIAS = createRequestTypes(
  `${namespace}/UPDATE_OWNER_NAME_ALIAS`,
);

export const updateOwnerNameAlias = makeApiActionCreatorV3(
  api.updateOwnerNameAlias,
  UPDATE_OWNER_NAME_ALIAS[START],
  UPDATE_OWNER_NAME_ALIAS[SUCCESS],
  UPDATE_OWNER_NAME_ALIAS[ERROR],
);

export const DELETE_OWNER_NAME_ALIAS = createRequestTypes(
  `${namespace}/DELETE_OWNER_NAME_ALIAS`,
);

export const deleteOwnerNameAlias = makeApiActionCreatorV3(
  api.deleteOwnerNameAlias,
  DELETE_OWNER_NAME_ALIAS[START],
  DELETE_OWNER_NAME_ALIAS[SUCCESS],
  DELETE_OWNER_NAME_ALIAS[ERROR],
);

export const REORDER_OWNER_NAME_ALIAS = createRequestTypes(
  `${namespace}/REORDER_OWNER_NAME_ALIAS`,
);

export const reorderOwnerAliasNames = makeApiActionCreatorV3(
  api.reorderOwnerAliasNames,
  REORDER_OWNER_NAME_ALIAS[START],
  REORDER_OWNER_NAME_ALIAS[SUCCESS],
  REORDER_OWNER_NAME_ALIAS[ERROR],
);

export const FETCH_OWNER_TAX_OFFICE_VALIDATION = createRequestTypes(
  `${namespace}/FETCH_OWNER_TAX_OFFICE_VALIDATION`,
);

export const fetchOwnerTaxOfficeValidation = makeApiActionCreatorV3(
  api.fetchOwnerTaxOfficeValidation,
  FETCH_OWNER_TAX_OFFICE_VALIDATION[START],
  FETCH_OWNER_TAX_OFFICE_VALIDATION[SUCCESS],
  FETCH_OWNER_TAX_OFFICE_VALIDATION[ERROR],
);